{
  "PHONE_CTRLS": {
    "EXTENSION_BANNER": {
      "TEXT": "Razširitev Chrome ni nameščena.",
      "CTA": "Namesti razširitev"
    },
    "TABS": {
      "PHONE": "Telefon",
      "SMS": "SMS",
      "HISTORY": "Zgodovina"
    },
    "HISTORY": {
      "OPEN": "Odprti",
      "RECENT": "Nedavni",
      "MISSED": "Zamujeni",
      "LOADING": "Nalaganje klicev ...",
      "EMPTY": "Ni klicev",
      "ERROR": "Klicev ni bilo mogoče naložiti",
      "CALL": "Pokliči nazaj",
      "CALL_STATUS": {
        "BUTTON": "Nastavi status klica",
        "TITLE": "Status klica",
        "SEARCH_PLACEHOLDER": "Iskanje statusov ...",
        "LOADING": "Nalaganje statusov ...",
        "NO_OPTIONS": "Noben status klica ni nastavljen",
        "NO_MATCH": "Noben status se ne ujema",
        "OPTIONS_ERROR": "Statusov ni bilo mogoče naložiti",
        "RETRY": "Poskusi znova",
        "CONFIRM_QUESTION": "Nastaviti »{status}« in rešiti pogovor?",
        "CONFIRM": "Potrdi",
        "BACK": "Nazaj",
        "CANCEL": "Prekliči",
        "SAVING": "Shranjevanje ...",
        "SAVE_ERROR": "Statusa ni bilo mogoče shraniti",
        "RESOLVE_ERROR": "Status je shranjen, vendar pogovora ni bilo mogoče rešiti"
      }
    },
    "SMS": {
      "NUMBER_PLACEHOLDER": "Telefonska številka, npr. +421903000000",
      "BODY_PLACEHOLDER": "Napišite sporočilo...",
      "SEGMENTS": "({segments} SMS)",
      "SEND": "Pošlji SMS",
      "SENDING": "Pošiljanje...",
      "SENT": "SMS poslan",
      "LOADING": "Nalaganje nabiralnikov SMS...",
      "NO_INBOX": "Ta račun nima nabiralnika SMS, zato SMS-a ni mogoče poslati.",
      "INVALID_NUMBER": "Vnesite številko v mednarodni obliki, vključno z začetnim +.",
      "ERROR": "SMS-a ni bilo mogoče poslati. Poskusite znova."
    },
    "ACTIONS": {
      "CONNECT": "Poveži se",
      "GO_TO_TAB": "Pojdi na ta zavihek",
      "DISCONNECT": "Prekini povezavo",
      "ANSWER": "Odgovori",
      "HANGUP": "Prekini klic",
      "HOLD": "Zadrži",
      "MUTE": "Utišaj mikrofon",
      "SILENCE": "Utišaj zvok",
      "TRANSFER": "Preveži",
      "COMPLETE_TRANSFER": "Dokončaj prevezavo",
      "RETURN_TO_CALLER": "Vrni se h klicatelju",
      "CANCEL_TRANSFER": "Prekliči prevezavo",
      "DIALPAD": "Prikaži tipkovnico",
      "OPEN_CONVERSATION": "Odpri pogovor"
    },
    "NOTIFICATIONS": {
      "INCOMING_CALL": "Dohodni klic",
      "INCOMING_CALL_FROM": "Dohodni klic od {name} ({number})",
      "INCOMING_CALL_FROM_NUMBER": "Dohodni klic s številke {number}",
      "ANSWER": "Odgovori",
      "DECLINE": "Zavrni"
    },
    "TRANSFER": {
      "TITLE": "Prevezava klica",
      "PLACEHOLDER": "Vnesite številko za prevezavo...",
      "SEARCH_PLACEHOLDER": "Iskanje agentov...",
      "TARGET_PLACEHOLDER": "Izbrani prejemnik prevezave",
      "CONFIRM": "Preveži",
      "MODE_DIRECT": "Preveži takoj",
      "MODE_CONSULT": "Najprej pokliči agenta",
      "CANCEL": "Prekliči"
    },
    "QUEUE_BREAK": {
      "CONFIRM_BREAK": "Ali ste prepričani, da želite iti na odmor za vse čakalne vrste?",
      "CONFIRM_READY": "Ali ste prepričani, da se želite vrniti v stanje pripravljenosti za vse čakalne vrste?",
      "CONFIRM_BREAK_QUEUE": "Ali ste prepričani, da se želite odjaviti iz čakalne vrste {queue}?",
      "CONFIRM_READY_QUEUE": "Ali ste prepričani, da se želite prijaviti v čakalno vrsto {queue}?",
      "LOGIN_TO_QUEUE": "Prijava",
      "LOGOUT_FROM_QUEUE": "Odjava",
      "LOGIN_TO_ALL_QUEUES": "Prijavi se v vse čakalne vrste",
      "LOGOUT_FROM_ALL_QUEUES": "Odjavi se iz vseh čakalnih vrst",
      "OPTION_LOGOUT": "Odjava",
      "OPTION_BREAK": "Odmor",
      "OPTION_LUNCH": "Kosilo",
      "OPTION_AWAY": "Odsoten",
      "OPTION_DO_NOT_DISTURB": "Ne moti",
      "OPTION_BUSINESS_TRIP": "Službena pot",
      "CONFIRM": "Potrdi",
      "CANCEL": "Prekliči"
    },
    "CONNECTION_ERROR": {
      "TITLE": "Ni povezave s telefonskim sistemom",
      "MESSAGE": "Videti je, da vaša internetna povezava ne deluje. Preverite jo in poskusite znova.",
      "CREDENTIALS_TITLE": "Telefonski sistem je zavrnil vaše poverilnice",
      "CREDENTIALS_MESSAGE": "Telefonski sistem je zavrnil uporabniško ime ali geslo, shranjeno v vašem profilu. Preverite ju v Nastavitvah profila ali se obrnite na skrbnika.",
      "CONFIGURATION_TITLE": "Telefonske nastavitve niso veljavne",
      "CONFIGURATION_MESSAGE": "Uporabniško ime SIP ali naslov strežnika ni v veljavni obliki, zato se telefon ne more povezati. Popravite to v Nastavitvah profila.",
      "NETWORK_SHORT": "Povezava ni uspela",
      "CREDENTIALS_SHORT": "Poverilnice zavrnjene",
      "CONFIGURATION_SHORT": "Neveljavne telefonske nastavitve",
      "RETRY": "Poskusi znova",
      "DISMISS": "Prekliči"
    },
    "CONNECTION_QUALITY": "Kakovost povezave",
    "CONNECTION_QUALITY_EXCELLENT": "Odlična",
    "CONNECTION_QUALITY_GOOD": "Dobra",
    "CONNECTION_QUALITY_FAIR": "Zadovoljiva",
    "CONNECTION_QUALITY_POOR": "Slaba",
    "CONNECTION_QUALITY_DISCONNECTED": "Prekinjena",
    "STATUS": {
      "OFFLINE": "Telefon offline",
      "IN_OTHER_TAB": "Telefon povezan v drugem zavihku",
      "CONNECTING": "Povezovanje...",
      "DISCONNECTING": "Prekinjanje povezave...",
      "ONLINE": "Telefon online",
      "DIALING": "Klicanje",
      "TRANSFERRING": "Prevezovanje klica...",
      "CONSULTING": "Pogovor z agentom",
      "CALLER_ON_HOLD": "Klicatelj je na čakanju",
      "BUSY": "Zasedeno",
      "DND": "DND",
      "UNAVAILABLE": "Nedosegljiv",
      "REJECTED": "Klic zavrnjen",
      "CALL_FAILED": "Klic ni uspel"
    },
    "QUEUES": {
      "MORE": "Več čakalnih vrst"
    }
  },
  "DIAL_REDIRECT": {
    "DIALING": "Klicanje {number}… Ta zavihek lahko zaprete.",
    "NO_NUMBER": "Številka ni podana. Uporabite ?number=+420..."
  },
  "PHONE_DIAL": {
    "PLACEHOLDER": "Vnesite telefonsko številko...",
    "ACTIONS": {
      "DIAL": "Pokliči številko",
      "DIAL_FROM": "Izberite številko, s katere kličete"
    },
    "DIAL_FROM": {
      "TITLE": "Kliči s številke nabiralnika"
    },
    "VALIDATION": {
      "REQUIRED": "Telefonska številka je obvezna",
      "INVALID_FORMAT": "Neveljavna oblika telefonske številke"
    }
  },
  "PHONE_AUDIO": {
    "TITLE": "Nastavitve in testiranje zvoka",
    "SELECT_DEVICE": "Izberite napravo...",
    "SYSTEM_DEFAULT": "Privzeta sistemska naprava",
    "SAVED": "Shranjeno",
    "DISCONNECTED_SUFFIX": "ni povezano",
    "DEVICE_DISCONNECTED": "Izbrana naprava ni povezana. Klici uporabljajo privzeto sistemsko napravo, dokler se znova ne poveže.",
    "MICROPHONE": {
      "TITLE": "Mikrofon",
      "START_TEST": "Preizkusi mikrofon",
      "STOP_TEST": "Ustavi preizkus",
      "LEVEL": "Raven:",
      "VERDICT": {
        "LISTENING": "Recite nekaj v mikrofon…",
        "SILENT": "Ne slišijo vas. Preverite, ali je mikrofon vklopljen in izbran pravi.",
        "LOW": "Slišijo vas le tiho. Izberite drug mikrofon ali prilagodite vhodno glasnost v sistemskih nastavitvah.",
        "GOOD": "Dober zvok — dobro vas slišijo."
      }
    },
    "SPEAKER": {
      "TITLE": "Zvočnik",
      "TEST": "Preizkusi zvočnik",
      "TESTING": "Preizkušanje...",
      "VOLUME": "Glasnost:",
      "USING_DEFAULT": "Izbrani izhod ni na voljo — predvajano prek privzete sistemske naprave."
    },
    "DONE": "Končano",
    "ERRORS": {
      "MICROPHONE_ACCESS": "Napaka pri dostopu do mikrofona. Preverite dovoljenja.",
      "MICROPHONE_PERMISSION_DENIED": "Dostop do mikrofona je blokiran. Dovolite ga v nastavitvah spletnega mesta v brskalniku, da lahko uporabljate telefon.",
      "MICROPHONE_SILENT": "Vaš mikrofon ne zaznava zvoka. Preverite nastavitve zvoka.",
      "EXTENSION_REQUIRED": "Telefonska razširitev ni zaznana. Namestite jo ali omogočite, da lahko uporabljate mikrofon.",
      "SPEAKER_TEST": "Napaka pri preizkusu zvočnika."
    }
  },
  "PHONE_STATUS": {
    "OFFLINE": "Offline",
    "ONLINE": "Online",
    "BUSY": "Zasedeno"
  },
  "QUEUE_STATUS": {
    "READY": "Pripravljen",
    "NOT_READY": "Ne sprejema klicev",
    "WRAP_UP": "Zaključevanje klica",
    "BREAK": "Odmor",
    "LUNCH": "Kosilo",
    "AWAY": "Odsoten",
    "DO_NOT_DISTURB": "Ne moti",
    "BUSINESS_TRIP": "Službena pot",
    "OTHER_CALL": "Drug klic",
    "QUEUE_CALL": "Klic iz čakalne vrste",
    "OFFLINE": "Offline",
    "ONLINE": "Online",
    "NO_ACCESS": "Brez telefona",
    "PARTIALLY_READY": "Delno pripravljen",
    "MIXED": "Mešano",
    "CHAT_ONLINE": "Online (klepet)",
    "CHAT_BUSY": "Zasedeno (klepet)",
    "CHAT_OFFLINE": "Offline (klepet)"
  }
}
